import React, {useState} from 'react';
import HeaderComponent from "../../component/base/header-component/HeaderComponent";
import FooterComponent from "../../component/base/footer-component/FooterComponent";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import OnboardInput from "../../component/base/onboard-input/OnboardInput";
import OnboardLabel from "../../component/base/onboard-label-component/OnboardLabel";

const PromotionCodePage = (props) => {
    const {t} = props.props;

    const [error, setError] = useState(null);
    const [promotionCode, setPromotionCode] = useState(null);

    return (
        <div>
            <HeaderComponent title={t('promotion_code_page.title')}
                             content={t('promotion_code_page.content')} showBack/>

            <div className="content-root">

                <OnboardLabel icon="promotion_code"
                              text={t('promotion_code_page.information')}/>

                <div className="h-20"></div>

                <OnboardInput placeholder={t('promotion_code_page.input_title')} onChange={(e) => setPromotionCode(e)}
                              error={error?.promotionCode}
                              value={promotionCode}/>

                <div className="h-20"></div>

                <OnboardButton label={t('promotion_code_page.use_code')}
                               onClick={() => console.log("ok")}/>

                <div className="h-204"></div>
            </div>

            <FooterComponent/>
        </div>
    );
};

export default PromotionCodePage;

